// @flow
import { graphql } from 'react-relay';

import './components/articles/articleSpellCheckStatusFields';

export const streamListQuery = graphql`
	query queries_StreamList_Query($page: Int!, $states: [String]) {
		viewer {
			...StreamList_viewer @arguments(page: $page, states: $states)
		}
	}
`;

export const usersQuery = graphql`
	query queries_UserList_Query($sortBy: String, $sortDirection: String) {
		viewer {
			...UserList_viewer @arguments(sortBy: $sortBy, sortDirection: $sortDirection)
		}
	}
`;

export const peopleQuery = graphql`
	query queries_PeopleList_Query {
		viewer {
			...PeopleList_viewer
		}
	}
`;

export const articleQuery = graphql`
	query queries_Article_Query($id: ID!, $section: ID!, $blockSlug: String!) {
		viewer {
			...Article_viewer @arguments(id: $id, section: $section, blockSlug: $blockSlug)
		}
		spellCheckStatus(id: $id) {
			...articleSpellCheckStatusFields @relay(mask: false)
		}
	}
`;

export const tvshowsQuery = graphql`
	query queries_TVShowApp_Query($page: Int!, $states: [String]) {
		viewer {
			...TVShowApp_viewer @arguments(page: $page, states: $states)
		}
	}
`;

export const tvshowQuery = graphql`
	query queries_TVShowQuery($id: ID!, $section: ID!) {
		viewer {
			...TVShow_viewer @arguments(id: $id, section: $section)
		}
	}
`;

export const articlesListQuery = graphql`
	query queries_ArticleListWrapper_Query($page: Int!, $blockSlug: String!, $section: ID!, $states: [ArticleStateType]) {
		viewer {
			...ArticleList_viewer @arguments(page: $page, blockSlug: $blockSlug, section: $section, states: $states)
		}
	}
`;

export const userQuery = graphql`
	query queries_UserQuery($id: ID!) {
		viewer {
			...UserEdit_viewer @arguments(id: $id)
		}
	}
`;

export const personQuery = graphql`
	query queries_PersonQuery($id: ID!) {
		viewer {
			...Person_viewer @arguments(id: $id)
		}
	}
`;

export const topicsQuery = graphql`
	query queries_TopicsQuery($section: ID!) {
		viewer {
			...TopicsApp_viewer @arguments(section: $section)
		}
	}
`;

export const categoriesQuery = graphql`
	query queries_CategoriesQuery($section: ID!) {
		viewer {
			...CategoriesApp_viewer @arguments(section: $section)
		}
	}
`;

export const infoStringQuery = graphql`
	query queries_InfoStringsQuery($blockSlug: String!) {
		viewer {
			...InfoStringList_viewer @arguments(blockSlug: $blockSlug)
		}
	}
`;

export const infoStringEditFormQuery = graphql`
	query queries_infoStringEditFormQuery($id: ID!) {
		viewer {
			...InfoStringEdit_viewer @arguments(id: $id)
		}
	}
`;

export const blocksQuery = graphql`
	query queries_BlockQuery {
		viewer {
			...BlockList_viewer
		}
	}
`;

export const blockAddFormQuery = graphql`
	query queries_blockAddFormQuery {
		viewer {
			...ArticleSelector_viewer
		}
	}
`;

export const blockEditFormQuery = graphql`
	query queries_blockEditFormQuery($id: ID!) {
		viewer {
			...BlockEdit_viewer @arguments(id: $id)
		}
	}
`;

export const homeQuery = graphql`
	query queries_homeQuery_Query {
		viewer {
			...home_viewer
		}
	}
`;

export const topicQuery = graphql`
	query queries_topicQuery_Query($id: ID!) {
		topic: node(id: $id) {
			...TopicEditor_topic
		}
	}
`;

export const categoryQuery = graphql`
	query queries_categoryQuery_Query($id: ID!) {
		category: node(id: $id) {
			...CategoryEditor_category
		}
	}
`;

export const epgItemQuery = graphql`
	query queries_EpgItem_Query($id: ID!) {
		epgitem: node(id: $id) {
			...EpgItem_epgitem
		}
		viewer {
			tvshows(first: -1) {
				edges {
					node {
						id
						title
					}
				}
			}
			...TopicSelector_viewer
		}
	}
`;

export const epgQuery = graphql`
	query queries_EpgQuery($currentDate: String) {
		viewer {
			...Epg_viewer @arguments(day: $currentDate)
		}
	}
`;

export const streamQuery = graphql`
	query queries_Stream_Query($id: ID!, $type: MediaFileTypeEnum) {
		stream: node(id: $id) {
			...Stream_stream
		}
		viewer {
			streamUrls: mediaFilesPaginate(pageSize: 100, page: 1, type: $type) {
				mediaFiles {
					id
					title
					filename
				}
			}
			...TopicSelector_viewer
			...ArticleSelector_viewer
		}
	}
`;

export const mediaFilesListQuery = graphql`
	query queries_MediaFilesList_Query(
		$page: Int!
		$topic: ID
		$searchText: String
		$show: String
		$types: [MediaFileTypeEnum]
		$sort: String
		$states: [MediaFileStateType]
	) {
		viewer {
			...MediaGalleryList_viewer
				@arguments(page: $page, topic: $topic, searchText: $searchText, show: $show, types: $types, sort: $sort, states: $states)
		}
	}
`;

export const mediaFilesBackgroundQuery = graphql`
	query queries_MediaFilesBackground_Query($page: Int!, $type: MediaFileTypeEnum, $states: [MediaFileStateType]) {
		viewer {
			...Background_viewer @arguments(page: $page, type: $type, states: $states)
		}
	}
`;

export const mainPageQuery = graphql`
	query queries_MainPage_Query($page: Int!, $states: [ArticleStateType]) {
		viewer {
			...Main_viewer @arguments(page: $page, states: $states)
		}
	}
`;



// WEBPACK FOOTER //
// src/queries.js